import React from 'react';
import { Button } from 'components';
import { useStaticQuery, graphql, Link } from 'gatsby';
import styled from 'styled-components';
import { getAltTagFromFileName } from 'utils';
import { GatsbyImage } from 'gatsby-plugin-image';

function GuidesAndManuals() {
  const { manMeasuringPlankOfWood } = useStaticQuery(graphql`
    query {
      manMeasuringPlankOfWood: file(relativePath: { eq: "home/man-measuring-plank-of-wood.png" }) {
        name
        childImageSharp {
          gatsbyImageData(width: 480, formats: [AUTO, WEBP, AVIF])
        }
      }
    }
  `);

  return (
    <Container>
      <div className="fade-in">
        <Image
          image={manMeasuringPlankOfWood.childImageSharp.gatsbyImageData}
          alt={getAltTagFromFileName(manMeasuringPlankOfWood.name)}
        />
        <Text>
          <h3>Guides & Manuals</h3>
          <p>
            Access expert guidance at your fingertips - download our comprehensive guides and
            manuals to master your next project.
          </p>
          <Button to="/guides-and-manuals/" style={{ width: '145px' }}>
            View More
          </Button>
        </Text>
      </div>
    </Container>
  );
}

const Container = styled.section`
  display: grid;
  grid-column: 1/13;
  grid-template-columns: subgrid;
  justify-items: center;
  padding-top: 40px;

  @media (width >= 900px) {
    padding-top: 100px;
  }

  > div {
    background-color: var(--connolly-grey);
    border-radius: 6px;
    grid-column: 1/-1;
    max-width: 470px;
    overflow: hidden;

    @media (width >= 900px) {
      display: grid;
      grid-template-columns: subgrid;
      grid-template-rows: auto auto;
      grid-column: 2/12;
      max-width: 1168px;
    }
  }
`;

const Text = styled.div`
  grid-column: 2/12;
  grid-row: 2/3;
  padding: 29px 1rem 34px;

  h3 {
    font-size: 2rem;
  }

  p {
    margin: 20px 0 39px;
  }

  @media (width >= 900px) {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 2/6;
    grid-row: 1/2;
    padding: 72px 1rem 40px;

    h3,
    p,
    a {
      grid-column: 1/6;
    }
  }
`;

const Image = styled(GatsbyImage)`
  grid-column: 1/-1;
  grid-row: 1/2;

  @media (width >= 900px) {
    grid-column: 6/11;
    width: calc(100% + 20px);
    position: relative;
    left: -20px;
  }

  @media (width >= 1000px) {
    grid-column: 7/11;
  }
`;

export default GuidesAndManuals;
